import { Controller } from "@hotwired/stimulus"

// Lazily loads the charts Turbo Frame and reloads it on a timer; changing the
// granularity or kiosk select re-points the frame. kioskSelect is optional —
// only the admin page (event-wide, filterable) declares it; the coordinator
// page (always single-kiosk) doesn't.
export default class extends Controller {
  static targets = [ "frame", "granularitySelect", "kioskSelect", "itemTab" ]
  static values  = {
    chartsUrl: String,
    interval:  { type: Number, default: 30000 },
    itemTab:   { type: String, default: "" },
  }

  connect() {
    if (!this.frameTarget.src) this.refresh()
    this._startTimer()
  }

  disconnect() {
    clearInterval(this._timer)
  }

  filtersChanged() {
    clearInterval(this._timer)
    this.refresh()
    this._startTimer()
  }

  refresh() {
    const g = this.granularitySelectTarget.value
    const kioskParam = this.hasKioskSelectTarget && this.kioskSelectTarget.value
      ? `&kiosk_id=${this.kioskSelectTarget.value}` : ""
    this.frameTarget.src = `${this.chartsUrlValue}?granularity=${g}${kioskParam}`
  }

  _startTimer() {
    this._timer = setInterval(() => this.frameTarget.reload(), this.intervalValue)
  }

  // The item-sales tabs (EventCore::Analytics::ItemSalesTableComponent) are
  // plain CSS radio tabs with no JS state of their own — a reload replaces
  // them wholesale and the server always re-checks the first one. This value
  // lives on this element, which the frame reload never touches, so it
  // survives across reloads; restoreItemTab re-applies it to the fresh markup.
  rememberItemTab(event) {
    this.itemTabValue = event.target.dataset.kioskId
  }

  restoreItemTab() {
    if (!this.itemTabValue) return

    const radio = this.itemTabTargets.find((el) => el.dataset.kioskId === this.itemTabValue)
    if (radio) radio.checked = true
  }
}
